import { Environment } from './defs';

export const environment: Environment = {
  apiUrl: 'https://qa-consoleadmin.acetech.com/api',
  idProvider: 'https://qa-auth.acetech.com/auth/realms/ACETECH',
  keycloakClientId: 'SSOAdmin',
  production: true,
  clickPreventionTimer: 10,
  requestTimeout: '60000',
};
